import { HTTP } from '@/services/http'
import { Settings } from '@/settings'

export class UserService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

	async login(data) {
		return await super.get('/login', data)
	}

	static logout() {
	    localStorage.removeItem('username')
	    localStorage.removeItem('usertoken')
	}

	static hasAuth() {
		return localStorage.getItem('username') && localStorage.getItem('usertoken')
	}

	static getAuth() {
		return {
			username: localStorage.getItem('username'),
			usertoken: localStorage.getItem('usertoken'),
		}
	}
}